module.exports = __webpack_public_path__ + "media/src/images/abouts/bg_image/about_image_web_pc-56e55de137a49741cbde845f10784b9f.jpg";